import {
    addFingerId,
    addLeads,
    getReserveInfo,
    reserve,
    updateReserveInfo,
} from '../api'

import {useSelect} from '../hooks/useSelect'
import {resetRecordModal, selectRecordModal, setRecordModalShow} from '../store'
import {useDispatch} from '../hooks/useReduxStore'

const {useEffect, useState} = React
const {Button, Checkbox, Form, Input, message, Modal, Select} = antd
const {Item} = Form

const RecordModal = () => {
    const recordModal = useSelect(selectRecordModal)
    const dispatch = useDispatch()
    const {isShow, showExtra, initialState} = recordModal
    const extra = initialState?.extra
    const [hasAlreadyProvidedInfo, setHasAlreadyProvidedInfo] = useState(false)
    const button_type = showExtra?.editType || extra?.editType
    const leadTitle = button_type?.includes("免费试用") ? "试用咨询" : button_type?.includes("立即订购") ? "订购咨询" : "咨询"


    // 致趣百川上报
    const escalationInfo = (params) => {
        try {
            window.myCollect.$customClick({
                action: '晓总管上报手机号',
                setUserFlag: {
                    PhoneNumber: initialState?.encrypted_phone,
                },
            })
            const datfingerId = localStorage.getItem('fingerprintId')
            if (datfingerId) {
                addFingerId({values: {fingerId: datfingerId}})
            }
            addLeads({
                values: {
                    xd_user_name: initialState?.user_account?.username, // 账号名
                    xd_team: initialState?.enterprise?.name || initialState?.enterprise?.shot_name, //团队名称
                    email: initialState?.user_account?.email, //邮箱
                    sourcepage: showExtra?.source || extra?.source, //来源页面
                    buttonclick: showExtra?.editType || extra?.editType, //操作按钮
                    ...(params || {}),
                },
            })
        } catch (error) {
        }
    }

    useEffect(() => {
        try {
            if (isShow && (extra?.source || showExtra?.source)) {
                getReserveInfo().then(({code, data}) => {
                    if (
                        localStorage.getItem('leadUserId') === initialState?.user_account?.id &&
                        localStorage.getItem('leadPosition')
                    ) {
                        setHasAlreadyProvidedInfo(true)
                        reserve({
                            values: {
                                source: showExtra?.source || extra?.source,
                                extra: showExtra?.source ? showExtra : extra,
                            },
                        })
                    } else {
                        escalationInfo()
                        reserve({
                            values: {
                                source: showExtra?.source || extra?.source,
                                extra: showExtra?.source ? showExtra : extra,
                            },
                        })
                    }
                })
            }
        } catch {
        }
    }, [extra, showExtra, isShow])

    const [form] = Form.useForm()

    //职位列表
    const positionList = [
        {
            label: '公司决策层',
            value: '1',
        },
        {
            label: '业务主管/经理',
            value: '2',
        },
        {
            label: '一线业务人员',
            value: '3',
        },
        {
            label: '其他',
            value: '4',
        },
    ]

    const handleCancel = () => {
        dispatch(setRecordModalShow(false))
        dispatch(resetRecordModal())
    }
    const handleUpdate = async () => {
        form.validateFields().then(({company, customer_email, real_name, position, products}) => {
            //上传留资个人信息
            updateReserveInfo({
                values: {
                    company,
                    real_name,
                    position,
                    customer_email,
                    products: "k",
                },
            })
                .then(({code}) => {
                    if (code === 0) {
                        message.success('提交成功')
                        localStorage.setItem('leadUserId', initialState?.user_account?.id)
                        localStorage.setItem('leadPosition', position)
                    } else {
                        message.error('提交失败')
                    }
                })
                .catch()
            escalationInfo({
                company, //公司
                full_name: real_name, //姓名
                job_title: positionList
                    .filter((k) => k.value === position)
                    .map((i) => ({...i, value: Number(i.value)})), //职位
                products_of_interest: "k", //感觉兴趣的产品
            })
        }).finally(() => {
            dispatch(setRecordModalShow(false))
            dispatch(resetRecordModal())
        })
    }
    if (hasAlreadyProvidedInfo) {
        return (
            <Modal
                className="record_container"
                data-testid="record-lead-container"
                width={498}
                maskClosable={false}
                destroyOnClose
                open={isShow}
                title={<div style={{height: 16}}/>}
                footer={null}
            >
                <div className="modal" data-testid="record-lead-modal">
                    <div
                        className="body"
                        data-testid="record-lead-modal-body"
                        style={{marginTop: 24}}
                    >
                        <i className="iconfont" style={{fontSize: 64}}
                           data-testid="record-lead-record-icon">&#xe823;</i>
                        <h2 className="record_received" data-testid="record-lead-modal-received">
                            已收到
                        </h2>
                        <div className="operates" data-testid="record-lead-modal-operates">
                        <span>
                          您的专属顾问将在 24 小时内与您取得联系，以下是我们的专用号码，您还可以添加顾问微信进行
                          1V1 沟通~
                        </span>
                        </div>
                        <div
                            className="connect"
                            data-testid="record-lead-modal-connect"
                            style={{marginTop: 50}}
                        >
                            <div className="phone_wrap" data-testid="record-lead-modal-phone-wrap">
                                <i className="iconfont tel_icon">&#xe6b1;</i>
                                <div className="phone" data-testid="record-lead-modal-phone">
                                    13689087523
                                </div>
                            </div>
                            <img
                                src="https://cdn-static.xiaoduoai.com/apphub/bitable/462263e4b00771faa7fee70305be2910.png"
                                width={83}
                                height={83}
                                alt=""
                            />
                        </div>
                        <Button type="primary" onClick={handleCancel} style={{marginTop: 32}}>
                            我知道了
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }
    return (
        <Modal
            className="record_container"
            data-testid="record-lead-container"
            width={520}
            maskClosable={false}
            destroyOnClose
            open={isShow}
            onCancel={handleCancel}
            cancelText="暂不补充"
            okText="提交信息"
            title={<h2 className="record_container_title" style={{fontWeight: "bold"}}>{leadTitle}</h2>}
            footer={null}
            style={{top: 50}}
        >
            <div className="modal" data-testid="record-lead-modal">
                <div
                    className="body"
                    data-testid="record-lead-modal-body"
                >
                    <div className="info_tips" data-testid="record-lead-modal-info-tips">
                        <i className="iconfont tips_icon"
                           data-testid="record-lead-modal-info-tips-icon">&#xe841;</i>
                        <span>提交信息后，您的专属顾问将在 24 小时内与您取得联系。</span>
                    </div>
                    <Form
                        // preserve={false}
                        form={form}
                        wrapperCol={{span: 24}}
                        className="customer_info_form"
                        data-testid="record-lead-modal-customer-info-form"
                        layout="vertical"
                    >
                        <Item
                            name="company"
                            rules={[{ message: '请输入您真实、完整的公司名称'}]}
                            label="您的公司全称"
                            required={false}
                        >
                            <Input placeholder="请输入您真实、完整的公司名称" allowClear/>
                        </Item>
                        <Item
                            name="real_name"
                            rules={[{ message: '请输入您的姓名'}]}
                            label="您的姓名"
                            required={false}
                        >
                            <Input placeholder="请输入您的姓名" allowClear/>
                        </Item>
                        <Item
                            name="phone"
                            rules={[{ message: '请选择您的电话号码'}]}
                            label="您的电话号码"
                            required={false}
                        >
                            <Input placeholder="请选择您的电话号码" allowClear/>
                        </Item>
                        <Item
                            name="position"
                            rules={[{message: '请选择您的职位'}]}
                            label="您的职位"
                            required={false}
                        >
                            <Select placeholder="请选择您的职位" allowClear options={positionList}/>
                        </Item>
                    </Form>
                    <div className="operates" data-testid="record-lead-modal-operates">
                        以下是我们的专用号码，您也可以直接添加顾问微信进行 1V1 沟通
                    </div>
                    <div
                        className="connect"
                        data-testid="record-lead-modal-connect"
                    >
                        <div className="phone_wrap" data-testid="record-lead-modal-phone-wrap">
                            <i className="iconfont tel_icon">&#xe6b1;</i>
                            <div className="phone" data-testid="record-lead-modal-phone">
                                13689087523
                            </div>
                        </div>
                        <img
                            src="https://cdn-static.xiaoduoai.com/apphub/bitable/462263e4b00771faa7fee70305be2910.png"
                            width={83}
                            height={83}
                            alt=""
                        />
                    </div>
                </div>
                <div className="submit_container">
                    <div className="submit_container_inner">
                        <Button type="primary" onClick={handleUpdate}>
                            提交信息
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

RecordModal.displayName = "RecordModal"

export default RecordModal
